import { useCallback, useEffect, useRef, useState } from 'react';

export default function useCopied() {
  const [showCopied, setShowCopied] = useState(false);

  const onCopy = useCallback(() => {
    setShowCopied(true);
  }, []);

  let timeoutRef = useRef(null);
  useEffect(() => {
    if (showCopied) {
      timeoutRef.current = setTimeout(() => {
        setShowCopied(false);
      }, 1500);
    }
  }, [showCopied]);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  });

  return [onCopy, showCopied];
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/hooks/use_copied.js